import React from "react";
import PropTypes from "prop-types";
import "./catalogMaintenance.css";

const CatalogMaintenanceShell = ({ children }) => (
  <div className="catalog-maintenance" data-theme="light">
    {children}
  </div>
);

CatalogMaintenanceShell.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CatalogMaintenanceShell;
